export default {"src":"/_next/static/media/modern-north-arrow.8b07d16a.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};